import OrderDropdown from './OrderDropdown';
import OrderDropdownContainer from './OrderDropdown.container';

export default OrderDropdownContainer(OrderDropdown);
